import axios from 'axios';

// In production, use relative path without /api prefix since backend handles it
export const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3100');

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    withCredentials: true, // Include cookies in requests
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Server responded with error status
            console.error('API Error:', error.response.data);
            
            // Handle authentication errors
            if (error.response.status === 401) {
                // Redirect to login if not already on login page
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
            
            // Handle rate limiting errors
            if (error.response.status === 429) {
                console.warn('Rate limited - too many requests. Please wait before retrying.');
                // Don't redirect on rate limit, just log and let the component handle it
            }
        } else if (error.request) {
            // Request was made but no response received
            console.error('Network Error:', error.request);
        } else {
            // Something else happened
            console.error('Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default apiClient;
